export { COUNTRIES } from './countries';

export const INITIAL_FORM_STATE = {
  name: '',
  company: '',
  email: '',
  jobTitle: '',
  reason: '',
  location: '',
  contactNo: '',
  message: '',
};

export const INPUT_CLASS = "h-[40px] w-full rounded-[4px] border border-[#d7e7ff] bg-[#fafcff] px-[14px] py-[10px] text-[#212a31] text-[14px] font-ibm-plex font-normal leading-[1.4] outline-none placeholder:text-[#b6c2ce] focus:border-[#1449ea] focus:ring-1 focus:ring-[#1449ea] transition-all";

export const LABEL_CLASS = "text-[#324452] text-[14px] font-ibm-plex font-normal leading-[20px] mb-[6px] flex items-center";

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
